import React, { useEffect, useState } from "react";
import "./Urgency_Section.css";
import { Link, useNavigate } from "react-router-dom";
import { FaClock, FaUserGraduate, FaArrowRight } from "react-icons/fa";
import InquiryFormModal from "../../common_components/InquiryFormModal/InquiryFormModal";

const UrgencySection = () => {
  const [showModal, setShowModal] = useState(false);

  const [timeLeft, setTimeLeft] = useState(
    9 * 24 * 60 * 60 + // 10 days
    11 * 60 * 60 + // 11 hours
    59 * 60 + // 59 minutes
      50, // 50 seconds
  );
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const days = String(Math.floor(seconds / 86400)).padStart(2, "0");
    const hrs = String(Math.floor((seconds % 86400) / 3600)).padStart(2, "0");
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");

    return { days, hrs, mins, secs };
  };

  const { days, hrs, mins, secs } = formatTime(timeLeft);
  return (
    <section className="urgency_section">
      <div className="container">
        <div className="urgency_wrapper">
          <div className="urgency_left">
            <span className="admission_badge">Admissions Open July 2026</span>

            <h2>
              Secure Your Admission Before
              <span> Seats Fill Up!</span>
            </h2>

            <p>
              Applications are now open for the upcoming academic session.
              Reserve your seat today and begin your learning journey with
              expert faculty, flexible online classes, and industry-recognized
              programs.
            </p>

            <div className="urgency_info">
              {/* <div className="info_box">
                <FaClock />
                <div>
                  <h6>Application Deadline</h6>
                  <p>31 August 2026</p>
                </div>
              </div> */}

              <div className="info_box">
                <FaUserGraduate />
                <div>
                  <h6>Limited Seats Available</h6>
                  <p>Admissions Closing Soon</p>
                </div>
              </div>
            </div>

            <button className="applyy_btn" onClick={() => setShowModal(true)}>
              Apply Now
              <FaArrowRight style={{ marginLeft: "8px" }} />
            </button>
          </div>

          <div className="right_section">
            <div className="timer-values">
              <div className="time-unit">
                <span>{days}</span>
                <label>DAYS</label>
              </div>
              <div className="time-unit">
                <span>{hrs}</span>
                <label>HRS</label>
              </div>

              <div className="time-unit">
                <span>{mins}</span>
                <label>MINS</label>
              </div>

              <div className="time-unit">
                <span>{secs}</span>
                <label>SECS</label>
              </div>
            </div>
            <div className="urgency_right">
              <div className="seat_card">
                <h3>Hurry!</h3>

                <h1>Only Few Seats Left</h1>

                <p>
                  Don't miss the opportunity to join one of the most trusted
                  online learning platforms.
                </p>

                <div className="pulse_circle"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <InquiryFormModal show={showModal} onHide={() => setShowModal(false)} />
    </section>
  );
};

export default UrgencySection;
